import { ArpMediaType } from '@arpeggi/shared'
import { theme } from '@arpeggi/ui'
import chroma from 'chroma-js'
import ColorThief from 'colorthief'
import { useState } from 'react'
import { getSampleCategoryColor } from '../../../__legacy__/components/platform/color'
import { useAsyncEffect } from '../../../__legacy__/components/platform/explore/common/utils'
import { deserializeSongFromStorage } from '../../../__legacy__/stores/song/SongStore'
import { deserializeStemFromStorage } from '../../../__legacy__/stores/song/stem/StemUtils'
import { IArpMedia } from '../../arp-registry/ArpMedia'

const getTokenColor = (media: IArpMedia) => {
  const { type, metadata } = media
  try {
    if (type === ArpMediaType.SAMPLE) return getSampleCategoryColor(metadata.tags[0])
    if (type === ArpMediaType.SONG)
      return deserializeSongFromStorage(metadata.arpeggiComposition).tokenColor
    return deserializeStemFromStorage(metadata.arpeggiComposition).tokenColor
  } catch (err) {
    return getSampleCategoryColor(metadata.tags[0]) || theme.colors.gray0400.value
  }
}

const thief = new ColorThief()

const stealColor = (src: string): Promise<string> =>
  new Promise((resolve) => {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.src = src + '?info=none' // workaround for cors issue
    image.addEventListener('load', () => {
      const color: [number, number, number] = thief.getColor(image)
      resolve(chroma(...color).hex())
    })
  })

export const useCSSGradient = (media: IArpMedia) => {
  const [gradient, setGradient] = useState<string>(theme.colors.blackA050.value)
  const [color, setColor] = useState<string>(theme.colors.blackA050.value)
  const status = useAsyncEffect(async () => {
    const { mintExtras } = media
    let color = theme.colors.gray0400.value
    if (mintExtras && mintExtras.coverImage) color = await stealColor(mintExtras.coverImage.url)
    else color = getTokenColor(media)
    const lighter = chroma(color).alpha(0.1).hex()
    const darker = chroma(color).alpha(0.5).hex()
    setColor(lighter)
    setGradient(`linear-gradient(180deg, ${darker} 0%, ${lighter} 100%)`)
  }, [media])
  return { gradient, color }
}
